import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { PageType } from '../../models/enums/pageType';


@Injectable({
  providedIn: 'root'
})
export class StaticPagesService {

  private apiUrl = `${environment.apiUrl}/staticPages`;

  constructor(private http: HttpClient) { }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`)
  }

  getByPageType(pageType: PageType, isHomePage: boolean = false): Observable<any> {
    return this.http.get(`${this.apiUrl}/getByPageType?pageType=${pageType}&isHomePage=${isHomePage}`);
  }

  getBlogList(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getBlogList`)
  }

  getBlogDetail(blogUrl: string): Observable<any> {
    const encodedUrl = encodeURIComponent(blogUrl);
    return this.http.get(`${this.apiUrl}/getBlogDetail?pageUrl=${encodedUrl}`)
  }

  getPoliciesKvkkDetail(blogUrl: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/getPoliciesKvkkDetail?pageUrl=${blogUrl}`)
  }
}
